<svelte:head>

    <title>Admins • Ämtler-Bon Admin</title>

</svelte:head>

<script>

    import SessionManager from "../components/utils/session.svelte";
    import Users from "../components/screens/users.svelte";

</script>

<SessionManager />

<section>

    <Users />

</section>


<style>

    section {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: flex-start;
        height: inherit;
        margin-left: 31vh;
    }

</style>
